import { render, staticRenderFns } from "./PacsButton.vue?vue&type=template&id=657c5c90&"
import script from "./PacsButton.vue?vue&type=script&lang=js&"
export * from "./PacsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports